import React from "react";
import {
  DefaultRouteParam,
  RouteConfig,
} from "../../../config/router/router.config";

export type AdminRouteParam = DefaultRouteParam;

export const adminRoute: RouteConfig = {
  name: "Admin",
  Component: React.lazy(() => import("./Admin.view")),
  path: `/user/admin`,
  isPrivate: true,

  options: {
    label: "Admin",
    testID: "MenuUserAdmin",
  },
};
